import React from 'react';
import video from '../../assets/Dignity Project Video1.mp4';
import img from '../../assets/dignity_hero_img.webp';
import reraLogo from '../../assets/rera_logo.jpeg';
import { MapPin, ShieldCheck } from 'lucide-react';

const ProjectHero = () => {
  return (
    <section className="relative h-[55vh] sm:h-[90vh] bg-gradient-to-r from-red-900 to-red-800 overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          poster={img}
          className="w-full h-full object-cover"
        >
          <source src={video} type="video/mp4" />
          {/* Fallback image in case video doesn't load */}
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${img})`
            }}
          ></div>
        </video>
        {/* Red gradient overlay for brand consistency */}
        {/* <div className="absolute inset-0 bg-gradient-to-r from-red-900/80 to-red-800/80"></div> */}
      </div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 h-full flex items-end pb-10">
        <div className="max-w-2xl">
          {/* <div className="mb-4">
            <span className="inline-block bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
              PROJECTS
            </span>
          </div>
          
          <div className=" w-fit bg-white p-2 mb-1 rounded-2xl">
            <img src={dignity} alt="" className='w-40 h-auto'/>
          </div> */}
          
          {/* RERA Registration Tag - Increased size with original style */}
          <div className="inline-flex bg-black/50 backdrop-blur-sm rounded-2xl p-4 gap-x-4 items-center shadow-2xl">
            <img src={reraLogo} alt="RERA" className="h-10 sm:h-14 w-auto brightness-200" />
            <div className="flex flex-col">
              <span className="text-[10px] sm:text-xs uppercase font-bold text-gray-300 leading-none mb-1.5">RERA Approved Project</span>
              <span className="text-sm sm:text-lg font-medium text-white tracking-wide">K-RERA/PRJ/KKD/041/2026</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      {/* <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white rounded-full mt-2"></div>
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default ProjectHero;